export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";

export const USER_LOGOUT = "USER_LOGOUT";

export const USER_LIST_REQUEST = "USER_LIST_REQUEST";
export const USER_LIST_SUCCESS = "USER_LIST_SUCCESS";
export const USER_LIST_FAIL = "USER_LIST_FAIL";

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";

export const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_FAIL = "USER_UPDATE_FAIL";

export const USER_UPDATE_SUB_REQUEST = "USER_UPDATE_SUB_REQUEST";
export const USER_UPDATE_SUB_SUCCESS = "USER_UPDATE_SUB_SUCCESS";
export const USER_UPDATE_SUB_FAIL = "USER_UPDATE_SUB_FAIL";

export const USER_UPDATE_DEVICE_REQUEST = "USER_UPDATE_DEVICE_REQUEST";
export const USER_UPDATE_DEVICE_SUCCESS = "USER_UPDATE_DEVICE_SUCCESS";
export const USER_UPDATE_DEVICE_FAIL = "USER_UPDATE_DEVICE_FAIL";

export const USER_EXPORT_REQUEST = "USER_EXPORT_REQUEST";
export const USER_EXPORT_SUCCESS = "USER_EXPORT_SUCCESS";
export const USER_EXPORT_FAIL = "USER_EXPORT_FAIL";

export const USER_DELETE_REQUEST = "USER_DELETE_REQUEST";
export const USER_DELETE_SUCCESS = "USER_DELETE_SUCCESS";
export const USER_DELETE_FAIL = "USER_DELETE_FAIL";
